import { useParams, useSearchParams } from "react-router-dom";
import { RouteContextWrapper } from "@/components/custom/providers/routeContextWrapper";

export default function CasePage() {
  const params = useParams<{ caseId: string }>();
  const [searchParams] = useSearchParams();

  return (
    <RouteContextWrapper
      resolvedParams={{ caseId: params.caseId ?? "default" }}
      resolvedSearchParams={{
        docIds: searchParams.get("docIds") ?? undefined,
        showThreadList: parseShowThreadList(searchParams.get("showThreadList")),
        prompt: searchParams.get("prompt") ?? undefined,
      }}
    />
  );
}

function parseShowThreadList(raw: string | null): boolean | undefined {
  if (raw === "false") return false;
  if (raw === "true") return true;
  return undefined;
}
